// extracted by mini-css-extract-plugin
export default {"colorBrand":"#254a91","colorWhite":"#fff","colorBlueBright":"#81a9f2","quantity":"quantity_JLWln","stepper":"stepper_bnnAG","quantityInput":"quantityInput_Z2Do6"};